import {
  FETCH_DATA_NOTIFICATION_ERROR,
  FETCH_DATA_NOTIFICATION_REQUEST,
  FETCH_DATA_NOTIFICATION_SUCCESS,
  UPDATE_SETTING_NOTIFICATION_ERROR,
  UPDATE_SETTING_NOTIFICATION_REQUEST,
  UPDATE_SETTING_NOTIFICATION_SUCCESS,
  READ_NOTIFICATION_ERROR,
  READ_NOTIFICATION_REQUEST,
  READ_NOTIFICATION_SUCCESS,
  GET_BADGE_NOTIFICATION_REQUEST,
  GET_BADGE_NOTIFICATION_SUCCESS,
  GET_BADGE_NOTIFICATION_ERROR,
} from "./actions";

export interface DataState {
  notification: {
    data: any;
    loading: boolean;
    error: Error | null;
    params: {
      page: number;
      page_size: number;
    };
    lastPage: number;
  };
  badgeNotification: number;
  settingNotification: any;
}
const initNotification: DataState["notification"] = {
  data: [],
  loading: false,
  error: null,
  params: {
    page: 1,
    page_size: 20,
  },
  lastPage: 0,
};
const initialState: DataState = {
  notification: initNotification,
  settingNotification: {},
  badgeNotification: 0,
};

const authReducer = (
  state: DataState = initialState,
  action: any
): DataState => {
  switch (action.type) {
    // notification
    case FETCH_DATA_NOTIFICATION_REQUEST:
      console.log("FETCH_DATA_NOTIFICATION_REQUEST", action.payload);
      return {
        ...state,
        notification: {
          ...state.notification,
          params: action.payload,
          loading: true,
        },
      };
    case FETCH_DATA_NOTIFICATION_SUCCESS: {
      console.log("FETCH_DATA_NOTIFICATION_SUCCESS", action.payload);
      const { params }: any = state.notification;

      const listData =
        params.page === 1
          ? action.payload.data
          : state.notification.data.concat(action.payload.data);
      console.log("listData", listData);

      return {
        ...state,
        notification: {
          ...state.notification,
          data: listData,
          loading: false,
          error: null,
          lastPage: action.payload?.last_page,
        },
      };
    }

    case FETCH_DATA_NOTIFICATION_ERROR:
      return {
        ...state,
        notification: {
          ...state.notification,
          loading: false,
          error: action.payload,
        },
      };
    case UPDATE_SETTING_NOTIFICATION_REQUEST:
      return {
        ...state,
      };
    case UPDATE_SETTING_NOTIFICATION_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_SETTING_NOTIFICATION_ERROR:
      return { ...state };

    case READ_NOTIFICATION_REQUEST: { //state.notification?.histories[0]?.read_status === 'Y'
      const updateStatusById = (data: any, ids: number[]) => {
        console.log("ids", ids);

        return data.map((item: any) => {
          if (ids.includes(item.histories[0]?.id) || ids.length === 0) {
            return {
              ...item,
              histories: [
                {
                  ...item.histories[0],
                  read_status: "Y",
                },
              ],
            };
          }
          return item;
        });
      };

      return {
        ...state,
        notification: {
          ...state.notification,
          data: updateStatusById(state.notification.data, action.payload?.ids),
          loading: true,
        },
      };
    }

    case READ_NOTIFICATION_SUCCESS: {
      const data = action.payload.data;
      const newData = state.notification.data.map((item: any) => {
        if (item.id === data.id) {
          return data;
        }
        return item;
      });
      return {
        ...state,
        notification: {
          ...state.notification,
          data: newData,
          loading: false,
        },
      };
    }

    case READ_NOTIFICATION_ERROR:
      return {
        ...state,
        notification: {
          ...state.notification,
          loading: false,
          error: action.payload,
        },
      };
    case GET_BADGE_NOTIFICATION_REQUEST:
      return {
        ...state,
      };
    case GET_BADGE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        badgeNotification: action.payload,
      };
    case GET_BADGE_NOTIFICATION_ERROR:
      return {
        ...state,
        badgeNotification: 0,
      };

    default:
      return state;
  }
};

export default authReducer;
